// src/components/planner/tabs/AgendaTab.tsx
// ABA AGENDA - Grade Semanal, Calendário Mensal e Assuntos

import React, { useState } from 'react';
import { Plus, ChevronLeft, ChevronRight, Pencil } from 'lucide-react';
import WeekGrid from '../components/WeekGrid';
import MonthCalendar from '../components/MonthCalendar';
import EventModal from '../modals/EventModal';
import SubjectModal from '../modals/SubjectModal';
import AbsenceSection from '../components/AbsenceSection';
import EditSubjectModal from '../modals/EditSubjectModal';

interface AgendaTabProps {
    allEvents: any[];
    subjects: any[];
    onReload: () => void;
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const AgendaTab: React.FC<AgendaTabProps> = ({
    allEvents,
    subjects,
    onReload,
    onShowToast
}) => {
    const [showEventModal, setShowEventModal] = useState(false);
    const [showSubjectModal, setShowSubjectModal] = useState(false);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [editingSubject, setEditingSubject] = useState<any | null>(null);


    const handlePrevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
    };

    const handleToday = () => {
        setCurrentMonth(new Date());
    };

    return (
        <div className="plnr-ag-content">
            {/* ========== GRADE SEMANAL ========== */}
            <div className="plnr-ag-section">
                <div className="plnr-ag-section-header">
                    <h3>Grade Semanal</h3>
                    <button
                        className="plnr-ag-btn-add"
                        onClick={() => setShowEventModal(true)}
                    >
                        <Plus size={18} />
                        Novo Evento
                    </button>
                </div>

                <WeekGrid
                    events={allEvents}
                    onReload={onReload}
                    onShowToast={onShowToast}
                />
            </div>

            {/* ========== CALENDÁRIO MENSAL ========== */}
            <div className="plnr-ag-section">
                <div className="plnr-ag-calendar-header">
                    <div className="plnr-ag-month-nav">
                        <button onClick={handlePrevMonth} className="plnr-ag-nav-btn">
                            <ChevronLeft size={20} />
                        </button>
                        <h3>
                            {currentMonth.toLocaleDateString('pt-BR', {
                                month: 'long',
                                year: 'numeric'
                            })}
                        </h3>
                        <button onClick={handleNextMonth} className="plnr-ag-nav-btn">
                            <ChevronRight size={20} />
                        </button>
                        <button onClick={handleToday} className="plnr-ag-today-btn">
                            Hoje
                        </button>
                    </div>
                </div>

                {/* CALENDÁRIO */}
                <MonthCalendar
                    currentMonth={currentMonth}
                    events={allEvents}
                    onReload={onReload}
                    onShowToast={onShowToast}
                />
            </div>

            {/* ========== ASSUNTOS PARA ESTUDAR ========== */}
            <div className="plnr-ag-section">
                <div className="plnr-ag-section-header">
                    <h3>Assuntos para Estudar</h3>
                    <button
                        className="plnr-ag-btn-add"
                        onClick={() => setShowSubjectModal(true)}
                    >
                        <Plus size={18} />
                        Novo Assunto
                    </button>
                </div>

                <div className="plnr-ag-subjects-grid">
                    {subjects.length > 0 ? (
                        subjects.map(subject => (
                            <div key={subject._id} className="plnr-ag-subject-card">
                                <div className="plnr-ag-subject-header">
                                    <h4>{subject.name}</h4>
                                    <span className={`plnr-ag-priority ${subject.priority}`}>
                                        {subject.priority === 'high' ? 'ALTA' :
                                            subject.priority === 'medium' ? 'MÉDIA' : 'BAIXA'}
                                    </span>
                                    <button
                                        className="plnr-btn-edit-inline"
                                        onClick={() => setEditingSubject(subject)}
                                        title="Editar assunto"
                                    >
                                        <Pencil size={13} />
                                    </button>
                                </div>
                                <div className="plnr-ag-subject-meta">
                                    <span>{subject.status}</span>
                                    {subject.totalMinutesStudied > 0 && (
                                        <span>
                                            {Math.floor(subject.totalMinutesStudied / 60)}h estudadas
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="plnr-ag-empty">Nenhum assunto cadastrado</p>
                    )}
                </div>
            </div>

            <AbsenceSection
                allEvents={allEvents}
                onShowToast={onShowToast}
            />

            {/* MODAIS */}
            {showEventModal && (
                <EventModal
                    selectedDay={0} // ou o dia selecionado da semana
                    weekStart={new Date()} // data de início da semana que você quer usar
                    onClose={() => setShowEventModal(false)}
                    onSave={() => {
                        setShowEventModal(false);
                        onReload();
                    }}
                    onShowToast={onShowToast}
                />
            )}

            {showSubjectModal && (
                <SubjectModal
                    onClose={() => setShowSubjectModal(false)}
                    onSave={() => {
                        setShowSubjectModal(false);
                        onReload();
                    }}
                    onShowToast={onShowToast}
                />
            )}

            {editingSubject && (
                <EditSubjectModal
                    subject={editingSubject}
                    onClose={() => setEditingSubject(null)}
                    onSave={() => { setEditingSubject(null); onReload(); }}
                    onShowToast={onShowToast}
                />
            )}
        </div>
    );
};

export default AgendaTab;